import { render } from "./PedirCitaView.vue?vue&type=template&id=a3d3559e&ts=true"
import script from "./PedirCitaView.vue?vue&type=script&lang=ts"
export * from "./PedirCitaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__